import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'visualFormat',
})
export class VisualFormatPipe implements PipeTransform {
	transform(value: string, type: string): string {
		if (!value || !type) {
			return 'Invalid pipe params';
		}

		if (type === 'date') {
			const date = new Date(value);

			if (date.toString() === 'Invalid Date') return 'Invalid Date';
			return `${date.getDate() + 1 < 10 ? '0' + (date.getDate() + 1) : date.getDate()}/${date.getMonth() < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1}/${date.getFullYear()}`;
		}

		return value;
	}
}
